import { IPreCasInterview } from '../../../../../types';

type Fields = Pick<
  IPreCasInterview,
  | 'whyUk'
  | 'whyUkOther'
  | 'selectedCourseReasons'
  | 'selectedCourseReasonsOther'
  | 'selectedUniReasons'
  | 'selectedUniReasonsOther'
  | 'uniChoiceReason1'
  | 'uniChoiceReason2'
  | 'uniChoiceReason3'
>;

export function getPageStatus(fields: Fields): { complete: boolean } {
  const {
    whyUk,
    whyUkOther,
    selectedCourseReasons,
    selectedCourseReasonsOther,
    selectedUniReasons,
    selectedUniReasonsOther,
    uniChoiceReason1,
    uniChoiceReason2,
    uniChoiceReason3,
  } = fields;

  const complete =
    whyUk !== '' &&
    (whyUk === 'Other' ? whyUkOther !== '' : true) &&
    (whyUk === 'I am not sure why I chose to study in the UK' ? whyUkOther !== '' : true) &&
    !!selectedCourseReasons &&
    selectedCourseReasons.length !== 0 &&
    (selectedCourseReasons.findIndex(
      reason => reason === 'Other' || reason === 'I am not sure why I chose this course',
    ) > -1
      ? selectedCourseReasonsOther !== ''
      : true) &&
    !!selectedUniReasons &&
    selectedUniReasons.length !== 0 &&
    (selectedUniReasons.findIndex(
      reason => reason === 'Other' || reason === 'I am not sure why I chose this university',
    ) > -1
      ? selectedUniReasonsOther !== ''
      : true) &&
    uniChoiceReason1 !== '' &&
    uniChoiceReason2 !== '' &&
    uniChoiceReason3 !== '';

  return { complete };
}
